<template>
  <v-slide-x-transition mode="out-in">
    <template v-if="apiDone && showCreateRow">
      <v-toolbar flat>
        <v-toolbar-title>
          {{ editedItem.id ? '編輯' : '創建' }}
          {{ $t(tableTitle.text) }}
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <template v-for="item in headerForCreate">
          <div v-if="item.show" :key="item.value" class="px-10-px">
            <template v-if="item.modifyType === 'autocomplete'">
              <v-autocomplete
                v-model="editedItem[item.dataKey]"
                :items="listData[item.listKey]"
                item-text="text"
                item-value="pid"
                dense
                hide-details
                :disabled="item.disabled"
                :label="item.text"
                :autofocus="item.dataKey === 'pid' && showCreateRow"
              ></v-autocomplete>
            </template>
            <template v-else-if="item.modifyType === 'text'">
              <v-text-field
                v-model="editedItem[item.dataKey]"
                hide-details
                :disabled="item.disabled"
                :label="item.text"
              ></v-text-field>
            </template>
            <template v-else-if="item.modifyType === 'select'">
              <v-select
                :items="[]"
                hide-details
                :disabled="item.disabled"
                v-model="editedItem[item.dataKey]"
              ></v-select>
            </template>
            <template v-else-if="item.modifyType === 'checkbox'">
              <v-checkbox
                v-for="data in listData[item.listKey]"
                :key="'checkbox-' + data.text"
                class="mt-0"
                :label="data.text"
                :value="data.value"
                hide-details
                :disabled="item.disabled"
                v-model="editedItem[item.dataKey]"
              ></v-checkbox>
            </template>
            <template v-else-if="item.modifyType === 'radio'">
              <v-radio-group hide-details v-model="editedItem[item.dataKey]">
                <v-radio
                  v-for="data in listData[item.listKey]"
                  :key="'radio-' + data.text"
                  :label="data.text"
                  :value="data.value"
                  hide-details
                  :disabled="item.disabled"
                ></v-radio>
              </v-radio-group>
            </template>

            <template v-else-if="item.value === 'actions'">
              <v-btn
                v-if="editedItem.id"
                small
                color="primary"
                class="mx-3"
                @click.stop="save"
              >
                儲存
              </v-btn>
              <v-btn
                v-else
                small
                color="primary"
                class="mx-3"
                @click.stop="create"
              >
                提交並複製預設密碼
              </v-btn>
              <v-btn small plain color="primary" @click="close">取消</v-btn>
            </template>
          </div>
        </template>
      </v-toolbar>
    </template>
  </v-slide-x-transition>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MemberCreate',

  inject: ['getUsers', 'switchCreateMemberArea', 'getDefaultPassword'],

  props: [
    'tableTitle',
    'headers',
    'showCreateRow',
    'activeTab',
    'apiDone',
    'listData'
  ],

  data() {
    return {
      headerForCreate: {},
      editedItem: {}
    }
  },

  computed: {
    ...mapState('member', ['editedData', 'userItems'])
  },

  watch: {
    showCreateRow(newVal) {
      if (!newVal) {
        this.close()
      }
    },
    editedData: {
      handler: function (newVal) {
        const data = JSON.parse(JSON.stringify(newVal))
        data.roles = data.rolesArr
        if (this.tableTitle.key === 'admin') {
          data.pid = this.listData.pidList[0].pid
        }
        if (!data.id) {
          data.pwd = this.getDefaultPassword(8)
        }
        this.editedItem = data
        this.setEidtedState()
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    this.setEditedData(JSON.parse(JSON.stringify(this.userItems)))
  },

  methods: {
    ...mapActions('message', ['setSnackbar']),
    ...mapActions('member', ['setEditedData']),

    setEidtedState() {
      this.headerForCreate = {}
      for (const i in this.headers) {
        const curr = JSON.parse(JSON.stringify(this.headers[i]))
        curr.show = true
        this.headerForCreate[curr.dataKey] = curr
        if (this.editedItem.id && ['pid', 'loginname'].includes(curr.dataKey)) {
          curr.disabled = true
        }
      }
      if (!this.editedItem.id) {
        this.headerForCreate.pwd = {
          show: true,
          text: '預設密碼',
          value: 'pwd',
          dataKey: 'pwd',
          listKey: '',
          valueType: 'text',
          modifyType: 'text',
          disabled: true,
          isRequired: true
        }
      }

      switch (this.activeTab) {
        case 1:
          this.headerForCreate.roles.show = false
          break
        case 2:
          this.headerForCreate.roles.show = true
          break
      }
    },
    save() {
      let { loginname, roles } = this.editedItem
      if (!roles.includes('NORMAL')) {
        roles = ['NORMAL', ...roles]
      }
      this.$api.common.user
        .setRoles({ loginname, roles: roles.toString() })
        .then((res) => {
          this.getUsers()
          this.close()
        })
    },
    create() {
      const { loginname, pid } = this.editedItem
      if (loginname === '' || pid === '') {
        this.setSnackbar({
          show: true,
          text: '請填寫必填欄位。',
          timeout: '1200',
          type: 'text'
        })
        return
      }
      const data = JSON.parse(JSON.stringify(this.editedItem))
      data.roles = data.roles.toString()
      delete data.rolesArr
      this.$api.common.user.createUser(data).then((res) => {
        this.$copyText(data.pwd).then(
          (e) => {
            this.setSnackbar({
              show: true,
              text: `創建成功並複製預設密碼 ${data.pwd}，請盡速將密碼貼給客戶。(預設密碼無法返查)`,
              timeout: '5000',
              type: 'text'
            })
            console.log(e)
          },
          (e) => {
            console.log(e)
          }
        )

        this.getUsers()
        this.close()
      })
    },
    close() {
      this.setEditedData()
      this.switchCreateMemberArea(false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
